import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3049985b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item-body" }
const _hoisted_2 = { class: "question-row-header" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "quest-answer"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "right-align" }

import { ref } from 'vue'
import { sanitizeHTML } from '@/hooks/utils/helper'

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'Detail',
  props: ['item'],
  setup(__props) {



const showAnswer = ref(false)

function toggleAnswer () {
  showAnswer.value = !showAnswer.value
}

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, null, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_el_button, {
          class: "answer-button",
          title: "查看答案和解析",
          onClick: toggleAnswer
        }, {
          default: _withCtx(() => [
            _createTextVNode("查看答案 ")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_tag, {
            round: "",
            type: "info"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.item.questionNo), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", {
            class: "quest-title",
            innerHTML: _unref(sanitizeHTML)(__props.item.question)
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", {
          class: "quest-select",
          innerHTML: _unref(sanitizeHTML)(__props.item.questionselect)
        }, null, 8, _hoisted_4),
        (showAnswer.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("span", {
                innerHTML: `答案：${__props.item.questionanswer}`
              }, null, 8, _hoisted_6),
              _createElementVNode("div", {
                class: "quest-describe",
                innerHTML: _unref(sanitizeHTML)(__props.item.questiondescribe)
              }, null, 8, _hoisted_7)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})